export function optional(fn, def) {
    try {
        var res = fn();
        if (!res && res !== 0)
            return def;
        return res;
    }
    catch (e) {
        return def;
    }
}
